import { render, staticRenderFns } from "./JournalsTableTable.vue?vue&type=template&id=812f1e4e"
import script from "./JournalsTableTable.vue?vue&type=script&lang=js"
export * from "./JournalsTableTable.vue?vue&type=script&lang=js"
import style0 from "./JournalsTableTable.vue?vue&type=style&index=0&id=812f1e4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports